module.exports = __webpack_public_path__ + "static/media/folder-open-solid.80179cae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/icons/folder-open-solid.svg
// module id = 668
// module chunks = 2